module.exports = __webpack_public_path__ + "resources/img/sp_solution.e1c0c632c6824e0f05429b6e2830611b.png";